import { createContext } from "react";

export const TextEditorContext = createContext({
  registerApplyStyle: () => {},
  registerSaveHandler: () => {},
  registerInsertImage: () => {},
  registerGetStyles: () => {},
  getAppliedStyles: () => {},
});
